import { useTranslation } from 'react-i18next'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import {
  StyledActions,
  StyledBadge,
  StyledCardHeader,
  StyledCardTitle,
  StyledCodeCard,
  StyledInfo,
  StyledScript,
} from './styled-components'

const MODULE = 'subscriptionForm:fidelity_maximizer_module'

interface LegacyPathButtonProps {
  label: string
  disabled: boolean
  loading: boolean
  onClick: () => void
}

const LegacyPathButton = ({ label, disabled, loading, onClick }: LegacyPathButtonProps) => (
  /* @ts-ignore */
  <SDButton block={true} disabled={disabled} isLoading={loading} onClick={onClick}>
    {label}
  </SDButton>
)

interface LegacyPathCardProps {
  hidden: boolean
  copyKey: string
  demoted: boolean
  disabled: boolean
  loading: boolean
  onClick: () => void
}

const LegacyPathCard = ({ hidden, copyKey, demoted, disabled, loading, onClick }: LegacyPathCardProps) => {
  const { t } = useTranslation()
  const isPulse = usePulseScope()

  if (hidden) {
    return null
  }

  const cta = t(`${MODULE}.${copyKey}.cta`)

  if (!demoted) {
    return (
      <>
        <SDNotification
          type='info'
          border
          primaryText={`<strong>${t(`${MODULE}.${copyKey}.card_title`)}</strong><br />${t(
            `${MODULE}.${copyKey}.script`,
          )}`}
        >
          <LegacyPathButton label={cta} disabled={disabled} loading={loading} onClick={onClick} />
        </SDNotification>
        <StyledInfo $pulse={isPulse}>{t(`${MODULE}.${copyKey}.info`)}</StyledInfo>
      </>
    )
  }

  return (
    <StyledCodeCard $muted $pulse={isPulse}>
      <StyledCardHeader $pulse={isPulse}>
        <StyledCardTitle $pulse={isPulse}>{t(`${MODULE}.legacy_path.card_title`)}</StyledCardTitle>
        <StyledBadge $muted $pulse={isPulse}>
          {t(`${MODULE}.legacy_path.badge`)}
        </StyledBadge>
      </StyledCardHeader>
      <StyledScript $pulse={isPulse} dangerouslySetInnerHTML={{ __html: t(`${MODULE}.${copyKey}.script`) }} />
      <StyledActions>
        <LegacyPathButton label={cta} disabled={disabled} loading={loading} onClick={onClick} />
      </StyledActions>
      <StyledInfo $pulse={isPulse}>{t(`${MODULE}.${copyKey}.info`)}</StyledInfo>
    </StyledCodeCard>
  )
}

export default LegacyPathCard
